export const PAGE_TITLE = 'Account Security';
export const PAGE_SUB_TITLE = 'Two factor authentication';
export const PAGE_DESCRIPTION = `In addition to your username and password, you'll have to enter a code (delivered via SMS) to sign in to your account.`;
export const SMS_TITLE = 'Authentication by SMS';
export const SMS_DESCRIPTION = 'Receive a unique code via SMS';
export const buttonText = (state: string) => `${state} 2FA Authentication`;
